var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AppLayout from '@/Layouts/AppLayout';
import { useForm } from '@inertiajs/react';
import { useRoute } from 'ziggy-js';
import Breadcrumb from '@/Jetstream/Breadcrumb';
import VetFields from './Partials/VetFields';
import handleUnsavedChanges from "../../Utils/handleUnsavedChanges";
import { Ziggy } from "@/ziggy";
export default function Show(_a) {
    var team = _a.team, branch = _a.branch, vet = _a.vet, permissions = _a.permissions;
    var route = useRoute(Ziggy);
    var init = __assign({}, vet);
    var form = useForm(init);
    handleUnsavedChanges(form);
    function submit() {
        form.put(route('team.branch.vet.update', { team: team, branch: branch, vet: vet }), {
            errorBag: 'update',
            preserveScroll: true,
            onSuccess: function (page) {
                form.setData(page.props.vet);
            }
        });
    }
    return (_jsx(AppLayout, __assign({ title: "Client", pageTitle: vet.name, breadCrumb: _jsx(Breadcrumb, { team: team, branch: branch, tab: "vets", vet: null, current: vet.name }) }, { children: _jsx("div", __assign({ className: "mt-6" }, { children: _jsxs("div", __assign({ className: "md:w-1/2 space-y-6 mb-6" }, { children: [_jsx(VetFields, { form: form }), _jsx("div", { children: _jsxs("button", __assign({ id: "submit", onClick: submit, type: "button", disabled: form.processing, className: "disabled:bg-gray-400 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500" }, { children: [!form.processing && "Save", form.processing && "Saving..."] })) })] })) })) })));
}
